import { useQuery } from '@tanstack/react-query'
import { QUERY_KEYS } from '../../constants/queryKeys'
import { getPartnerPMSProfiles } from '../../api/partner'
function useGetPartnerPMSProfiles(id?: string) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_PARTNER_PMS_PROFILES, id],
      queryFn: () => getPartnerPMSProfiles(id),
      enabled: !!id,
   })
}
export { useGetPartnerPMSProfiles }
export default useGetPartnerPMSProfiles
